module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQUlEQVQ4jcVSoW4CQRRcUYFAVFQikAhERWXFmt7NNekfkLSysqKi8pIKcvc2OYWqqKhAICsQiH4AH1CBOHHHLDmLqEBQ0QUauKOg+pJnXmZm37xZpY6owNh3X5hUAnS4PIGwA7EDCD9hmEI48oVJEE8fIVxCuLiK8/Ndcq+oQzh0oL96tPVyUUc8fT2Q/NPG3q4FEOd3EFo/yu+DKG+s5p5hyxc+QOxkV8RONgJm9nxjeFZ+l7QGod0SWKxt6DCtVZGVUgpd23QbfCCahpBM615Rr0zif8uTWdvlPYRh6smsXYk1bOkkPVVKKeULk5JDzau8eoYtiB2sBxCOS7LOVkdD1zbRtc3riBfusS8IOxsBw8ujPpFwuLMWhG+HkW2/1FoQ5Q0I5w4kiPkEsX1nbwzDF0im96bgEsh0mNb2An/VN6asSJ8N5DHrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/update_btn.png
// module id = RNDo
// module chunks = 1